import React from "react";
import { ChoiceTimeSet } from "./components";
const ChoiceTimeSetContainer = React.memo(({ handlerClick, onSave }) => {
    return (React.createElement(ChoiceTimeSet, { handlerClick: handlerClick, onSave: onSave }));
});
export default ChoiceTimeSetContainer;
